import "pattern.css/dist/pattern.min.css";
import React from "react";
import { SiteLayout } from "./src/components/SiteLayout";

export const wrapPageElement = ({ element }) => (
  <SiteLayout>{element}</SiteLayout>
);
